/** @format */

import * as React from "react";
import { Flex, Image, Text } from "@chakra-ui/react";
import { commonInfo } from "@common/en";
import theme from "@src/style/theme";
import colors from "@src/style/colors";
import dompurify from "dompurify";

export const About_Intro_EN: React.FC = () => {
  const sanitizer = dompurify.sanitize;
  const basePaddingX = {
    base: "20px",
    sm: "20px",
    md: "65px",
    lg: "108px"
  };
  const basePaddingY = {
    base: "50px",
    sm: "70px",
    md: "80px",
    lg: "100px"
  };

  return (
    <Flex
      position={"static"}
      width={"100%"}
      flexDirection={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      backgroundColor={colors.white}
      paddingX={basePaddingX}
      paddingY={basePaddingY}>
      <Flex
        width={"100%"}
        maxW={theme.breakpoints.mx}
        position={"static"}
        direction={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        gap={{
          base: "5vw",
          sm: "4.2vw",
          md: "3vw",
          lg: "3vw"
        }}
        backgroundColor={colors.white}>
        <Text
          wordBreak={"keep-all"}
          fontSize={{
            base: "32px",
            sm: "42px",
            md: "46px",
            lg: "65px"
          }}
          fontWeight={"900"}
          bgGradient="linear(to-tl,#01F6FF 
      , #007BFF)"
          bgClip={"text"}
          textAlign={"center"}
          dangerouslySetInnerHTML={{
            __html: sanitizer(commonInfo.about_intro.title)
          }}
        />
        <Image
          width={{
            base: "32vw",
            sm: "20vw",
            md: "16vw",
            lg: "14vw"
          }}
          src={`${commonInfo.about_intro.img}`}
        />
        <Text
          wordBreak={"keep-all"}
          color={colors.coolGray200}
          fontSize={{
            base: "16px",
            sm: "18px",
            md: "17px",
            lg: "22px"
          }}
          fontWeight={"400"}
          textAlign={"center"}
          dangerouslySetInnerHTML={{
            __html: sanitizer(commonInfo.about_intro.description)
          }}
        />
      </Flex>
    </Flex>
  );
};

export default About_Intro_EN;
